<app-toast />

<section class="indicadores">
    <div class="indicadores-inner">
        <app-card-content [border]="false" [title]="'Indicadores'" [subtitle]="'Índices de correção e salário mínimo'" [icon]="'pi pi-chart-line'">
            <p-button
                card-header
                label="Atualizar Indicadores"
                icon="pi pi-sync"
                severity="primary"
                [loading]="atualizando()"
                (click)="atualizarIndicadores()"
                pTooltip="Importa INPC e SELIC do serviço de consulta"
                tooltipPosition="left"
                [appCan]="rolePermissaoEditar"
            />

            <!-- Seletor de indicador -->
            <div class="flex justify-between items-center mb-4">
                <div class="mx-auto">
                    <p-selectbutton [options]="tiposIndicador" [ngModel]="tipo()" (ngModelChange)="onTipoChange($event)" optionLabel="label" optionValue="value" [unselectable]="true" class="flex flex-wrap justify-center gap-2" styleClass="w-33">
                        <ng-template let-option pTemplate="item">
                            <div class="flex items-center">
                                <span>{{ option.label }}</span>
                            </div>
                        </ng-template>
                    </p-selectbutton>
                </div>
            </div>

            <!-- Filtros -->
            <app-filtros-bar (limpar)="limparFiltros()" (filtrar)="aplicarFiltros()">
                <app-filtro-campo label="Pesquisar" [wide]="true" inputId="indicadores-filtro-texto">
                    <input id="indicadores-filtro-texto" pInputText type="text" class="w-full" [ngModel]="filtroTexto()" (ngModelChange)="filtroTexto.set($event)" (keyup.enter)="aplicarFiltros()" placeholder="Pesquisar por data ou valor..." />
                </app-filtro-campo>
            </app-filtros-bar>

            <!-- Barra de status -->
            <div class="flex justify-between items-center gap-3 mb-4">
                <span class="text-sm text-surface-400 dark:text-surface-500">
                    <span class="font-bold text-surface-700 dark:text-surface-200">{{ totalRecords() }}</span>
                    {{ totalRecords() === 1 ? 'registro' : 'registros' }}
                </span>
                <app-table-view-switcher [(viewMode)]="currentView" />
            </div>

            @if (currentView() === 'card') {
                <app-card-sort-pills class="mb-4" [opcoes]="sortOpcoes" [(field)]="sortField" [(order)]="sortOrder" (fieldChange)="onSortCardChange()" (orderChange)="onSortCardChange()" />
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6">
                    @for (linha of linhasPagina(); track linha.chave) {
                        <app-card-container>
                            <div class="indicador-topo">
                                <p-badge [value]="formatarValor(linha)" badgeSize="large" [severity]="ehSalario ? 'success' : 'info'" />
                            </div>
                            <div class="mt-4 text-xs space-y-1">
                                @if (ehSalario) {
                                    <div class="flex justify-between">
                                        <span class="text-muted-color">Data Início:</span>
                                        <span class="font-semibold">{{ formatarData(linha.data) }}</span>
                                    </div>
                                    <div class="flex justify-between">
                                        <span class="text-muted-color">Data Fim:</span>
                                        <span class="font-semibold">{{ formatarData(linha.dataFim) || '—' }}</span>
                                    </div>
                                } @else {
                                    <div class="flex justify-between">
                                        <span class="text-muted-color">Vigência:</span>
                                        <span class="font-semibold">{{ formatarData(linha.data) }}</span>
                                    </div>
                                }
                            </div>
                        </app-card-container>
                    } @empty {
                        <div class="col-span-full flex flex-col items-center justify-center py-12 text-surface-400">
                            <i class="pi pi-inbox text-5xl mb-3"></i>
                            <span>Nenhum registro encontrado.</span>
                        </div>
                    }
                </div>
            } @else {
                <p-table
                    [value]="linhasPagina()"
                    [loading]="carregando()"
                    dataKey="chave"
                    styleClass="p-datatable-sm indicadores-table"
                    [customSort]="true"
                    [sortField]="sortField()"
                    [sortOrder]="sortOrder()"
                    (onSort)="onSortChange($event)"
                    stripedRows
                >
                    <ng-template pTemplate="header">
                        @if (ehSalario) {
                            <tr>
                                <th pSortableColumn="valor" class="w-56 text-right">
                                    <strong>Valor</strong>
                                    <p-sortIcon field="valor" />
                                </th>
                                <th pSortableColumn="data">
                                    <strong>Data Início</strong>
                                    <p-sortIcon field="data" />
                                </th>
                                <th><strong>Data Fim</strong></th>
                            </tr>
                        } @else {
                            <tr>
                                <th pSortableColumn="data">
                                    <strong>Data</strong>
                                    <p-sortIcon field="data" />
                                </th>
                                <th pSortableColumn="valor" class="w-56 text-right">
                                    <strong>Valor</strong>
                                    <p-sortIcon field="valor" />
                                </th>
                            </tr>
                        }
                    </ng-template>

                    <ng-template pTemplate="body" let-linha>
                        @if (ehSalario) {
                            <tr>
                                <td class="text-right font-medium">{{ formatarValor(linha) }}</td>
                                <td>{{ formatarData(linha.data) }}</td>
                                <td>{{ formatarData(linha.dataFim) || '—' }}</td>
                            </tr>
                        } @else {
                            <tr>
                                <td>{{ formatarData(linha.data) }}</td>
                                <td class="text-right font-medium">{{ formatarValor(linha) }}</td>
                            </tr>
                        }
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="ehSalario ? 3 : 2">
                                <div class="flex flex-col items-center gap-2 py-10 text-surface-400">
                                    <i class="pi pi-inbox text-3xl"></i>
                                    <span class="text-sm">Nenhum registro encontrado.</span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            }

            <p-paginator (onPageChange)="onPageChange($event)" [first]="first()" [rows]="rows()" [totalRecords]="totalRecords()" [rowsPerPageOptions]="[10, 15, 20]" [appendTo]="'body'" />
        </app-card-content>
    </div>
</section>
